module.exports = __webpack_public_path__ + "static/media/Nasscom.47dca23d.png";